export default {
  tipoCorrelativa: {},
  tipoCorrelativas: [],
  fields: {},
  errorArray: [],
  dialog: false,
};
